import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import '../Motorrad.css';
import { sendFrontAction } from '../services/api'; 

const CATEGORIES = ['M', 'Sport', 'Tour', 'Roadster', 'Adventure'];

// Вспомогательная функция для форматирования фонового текста
const formatBgName = (name) => {
    if (!name) return '';
    const cleanName = name.replace(/^BMW\s+/i, '');
    const words = cleanName.split(' ');
    if (words.length <= 2) {
        return words.join('\n');
    }
    const mid = Math.ceil(words.length / 2);
    return words.slice(0, mid).join(' ') + '\n' + words.slice(mid).join(' ');
};

const Motorrad = () => {
    const [activeTab, setActiveTab] = useState('M');
    const [motoData, setMotoData] = useState({});
    const [loading, setLoading] = useState(true);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);

    const navigate = useNavigate();

    const handleNavigate = (path) => {
        navigate(path);
    };

    useEffect(() => {
        window.scrollTo(0, 0);

        sendFrontAction('motorrad', {}, 'GET')
            .then((resData) => {
                if (resData && resData.success && Array.isArray(resData.data)) {
                    const grouped = CATEGORIES.reduce((acc, cat) => {
                        acc[cat] = [];
                        return acc;
                    }, {});

                    resData.data.forEach((item) => {
                        const cat = item.Category || item.category;

                        if (cat && grouped[cat]) {
                            const imageUrl = item.bike_image || item.bikeImage || item.mainImage;
                            const modelName = item.bikeModel || item.name;

                            grouped[cat].push({
                                id: item.id,
                                slug: item.slug || item.id,
                                name: modelName,
                                bgName: formatBgName(modelName),
                                image: imageUrl || '/assets/placeholder.png'
                            });
                        }
                    });

                    setMotoData(grouped);
                } else {
                    console.error('Ошибка в структуре ответа бэкенда:', resData);
                }
                setLoading(false);
            })
            .catch((err) => {
                console.error('Ошибка при получении списка моделей:', err);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 992);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const activeIndex = CATEGORIES.indexOf(activeTab);

    const heroStyle = {
        backgroundImage: `linear-gradient(rgba(0,0,0,0.2), rgba(0,0,0,0.2)), url(${
            process.env.PUBLIC_URL + (isMobile ? '/assets/vertical/header-bg_vertical.jpg' : '/assets/horizontal/motorrad_bg.jpg')
        })`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
    };

    return (
        <div className="motorrad-page">
            <section className="motorrad-hero" style={heroStyle}>
                <div className="hero-content">
                    <h1>BMW R 1300 GS</h1>
                    <p>СОЗДАН ДЛЯ ПРИКЛЮЧЕНИЙ.</p>
                    <button className="btn-outline">
                        <Link to="/bmw-r-1300-gs" style={{ color: 'inherit', textDecoration: 'none' }}>
                            УЗНАТЬ БОЛЬШЕ
                        </Link>
                    </button>
                </div>
            </section>

            <section className="models-section">
                <div className="models-header">
                    <h2>МОДЕЛЬНЫЙ РЯД</h2>
                    <ul className="models-filter">
                        {CATEGORIES.map((tab) => (
                            <li
                                key={tab}
                                className={activeTab === tab ? 'active' : ''}
                                onClick={() => setActiveTab(tab)}
                            >
                                {tab}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="models-slider-viewport">
                    {loading ? (
                        <div style={{ color: '#fff', textAlign: 'center', padding: '100px' }}>
                            Загрузка моделей...
                        </div>
                    ) : (
                        <div
                            className="slider-track"
                            style={isMobile ? {} : { transform: `translateX(-${activeIndex * 100}%)` }}
                        >
                            {CATEGORIES.map((catName) => {
                                const currentCategoryModels = motoData[catName] || [];

                                return (
                                    <div
                                        key={catName}
                                        className={`category-slide ${activeTab === catName ? 'mobile-active' : ''}`}
                                    >
                                        {currentCategoryModels.length === 0 ? (
                                            <div style={{ color: '#aaa', textAlign: 'center', padding: '50px 0', width: '100%' }}>
                                                В данной категории пока нет доступных моделей
                                            </div>
                                        ) : (
                                            <div className="models-grid">
                                                {/* Левая колонка (первые 2 модели) */}
                                                <div className="grid-column-left">
                                                    {currentCategoryModels.slice(0, 2).map((model, index) => (
                                                        /* 🔥 Вся карточка теперь является единой ссылкой */
                                                        <Link
                                                            key={model.id}
                                                            to={`/motorrad/${model.slug}`}
                                                            className={`model-card ${index === 0 ? 'large-height' : 'small-height'}`}
                                                            style={{ textDecoration: 'none', color: 'inherit' }}
                                                        >
                                                            <div className="card-bg-content">
                                                                <span className="model-series-vertical">{catName}</span>
                                                                <span className="model-name-bg">
                                                                    {model.bgName.replace(/\n/g, ' ')}
                                                                </span>
                                                            </div>

                                                            <div className="model-image-link">
                                                                <img src={model.image} alt={model.name} />
                                                            </div>

                                                            <div className="model-info">
                                                                <h3>{model.name}</h3>
                                                            </div>
                                                        </Link>
                                                    ))}
                                                </div>

                                                {/* Правая колонка (3-я и 4-я модели) */}
                                                <div className="grid-column-right">
                                                    {currentCategoryModels.slice(2, 4).map((model) => (
                                                        /* 🔥 Вся карточка теперь является единой ссылкой */
                                                        <Link
                                                            key={model.id}
                                                            to={`/motorrad/${model.slug}`}
                                                            className="model-card equal-height"
                                                            style={{ textDecoration: 'none', color: 'inherit' }}
                                                        >
                                                            <div className="card-bg-content">
                                                                <span className="model-series-vertical">{catName}</span>
                                                                <span className="model-name-bg">
                                                                    {model.bgName.split('\n').map((line, i) => (
                                                                        <React.Fragment key={i}>
                                                                            {line}
                                                                            <br />
                                                                        </React.Fragment>
                                                                    ))}
                                                                </span>
                                                            </div>

                                                            <div className="model-image-link">
                                                                <img src={model.image} alt={model.name} />
                                                            </div>

                                                            <div className="model-info">
                                                                <h3>{model.name}</h3>
                                                            </div>
                                                        </Link>
                                                    ))}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>

                <div className="models-button">
                    <Link to="/moto_models" className="btn-show-all">ПОКАЗАТЬ ВСЕ</Link>
                </div>
            </section>

            {/* РАЗДЕЛ СЕРВИСНЫХ КАРТОЧЕК */}
            <section className="motorrad-service-card">
                <div className="service-card dark-card" onClick={() => handleNavigate('/service-request')}>
                    <div className="card-overlay"></div>
                    <div className="service-card-content">
                        <h2 className="service-title">
                            ЗАПИСЬ <br />
                            <span className="outline-text">НА СЕРВИС</span>
                        </h2>
                        <button className="service-btn">ОСТАВИТЬ ЗАЯВКУ</button>
                    </div>
                    <img src="/assets/motorrad_cards/service-bg.jpg" alt="Service" className="card-bg-img" />
                </div>

                <div className="service-card blue-card" onClick={() => handleNavigate('/test-drive')}>
                    <div className="service-card-content">
                        <h2 className="service-title">
                            ЗАПИСЬ <br />
                            <span className="outline-text">НА ТЕСТ-ДРАЙВ</span>
                        </h2>
                        <button className="service-btn">ЗАПИСАТЬСЯ</button>
                    </div>
                    <img src="/assets/motorrad_cards/testdrive-bg.jpg" alt="Test Drive" className="card-bg-img" />
                </div>
            </section>
        </div>
    );
};

export default Motorrad;